import { render, staticRenderFns } from "./Guv.vue?vue&type=template&id=f98f3ffc&"
import script from "./Guv.vue?vue&type=script&lang=ts&"
export * from "./Guv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports